
/*
 *  ------------------------------
 *   GENERATED CODE - DO NOT EDIT
 *  ------------------------------
 *
 * This file auto-generated by ClosetPro.VisualEditors/codegen/gen-config-options.mjs.
 *
 */

import { MeasurementUnits } from "../measurement";
import { OptionalProperties } from "../json/optional-properties";

export interface MeasurementUnitsConfig {
    units: MeasurementUnits,
};

export type MaterialConfig = {
    assetId: string,
    type: string,
    color: string,
    tint: string,
    cubemap: string,
    cubemapSuffix: string,
    slot: string,
}
export type MaterialOptions = OptionalProperties<MaterialConfig>;

export const materialDefaults: MaterialConfig = {
    assetId: null,
    type: null,
    color: null,
    tint: null,
    cubemap: null,
    cubemapSuffix: null,
    slot: null,
}

export type Vector3Config = {
    x: number,
    y: number,
    z: number,
}
export type Vector3Options = OptionalProperties<Vector3Config>;

export const vector3Defaults: Vector3Config = {
    x: 0,
    y: 0,
    z: 0,
}

export type ClosetUnitViewConfig = {
    standardHeights: number[],
}
export type ClosetUnitViewOptions = OptionalProperties<ClosetUnitViewConfig>;

export const closetUnitViewDefaults: ClosetUnitViewConfig = {
    standardHeights: [],
}

export type DoorViewConfig = {
    defaultFrameStyle: string,
    defaultPanelStyle: string,
}
export type DoorViewOptions = OptionalProperties<DoorViewConfig>;

export const doorViewDefaults: DoorViewConfig = {
    defaultFrameStyle: "frame_original_2in",
    defaultPanelStyle: "panel_raised",
}

export type DrawerViewConfig = {
    defaultFrameStyle: string,
    defaultPanelStyle: string,
}
export type DrawerViewOptions = OptionalProperties<DrawerViewConfig>;

export const drawerViewDefaults: DrawerViewConfig = {
    defaultFrameStyle: "frame_original_2in",
    defaultPanelStyle: "panel_raised",
}

export type ParametricPartViewConfig = {
    defaultFenceStyle: string,
}
export type ParametricPartViewOptions = OptionalProperties<ParametricPartViewConfig>;

export const parametricPartViewDefaults: ParametricPartViewConfig = {
    defaultFenceStyle: "Fence.obj",
}

export type HandleViewConfig = {
    defaultStyle: string,
    defaultMaterials: MaterialConfig[],
}
export type HandleViewOptions = OptionalProperties<HandleViewConfig>;

export const handleViewDefaults: HandleViewConfig = {
    defaultStyle: null,
    defaultMaterials: [],
}

export type VerticalPanelViewConfig = {
    standardHeights: number[],
}
export type VerticalPanelViewOptions = OptionalProperties<VerticalPanelViewConfig>;

export const verticalPanelViewDefaults: VerticalPanelViewConfig = {
    standardHeights: [],
}

export type WallViewConfig = {
    standardHeights: number[],
    hideStart: boolean,
    material: MaterialOptions,
}
export type WallViewOptions = OptionalProperties<WallViewConfig>;

export const wallViewDefaults: WallViewConfig = {
    standardHeights: [],
    hideStart: false,
    material: { type: "WallPaint" },
}

export type CameraConfig = {
    position: Vector3Config,
    rotation: Vector3Config,
    verticalFov: number,
}
export type CameraOptions = OptionalProperties<CameraConfig>;

export const cameraDefaults: CameraConfig = {
    position: {x: 0, y: 0, z:0},
    rotation: {x: 0, y: 0, z:0},
    verticalFov: 50,
}

export type DirectionalLightingViewConfig = {
    alt: number,
    az: number,
    temperature: number,
}
export type DirectionalLightingViewOptions = OptionalProperties<DirectionalLightingViewConfig>;

export const directionalLightingViewDefaults: DirectionalLightingViewConfig = {
    alt: 0.3737963267948965,
    az: 4.515,
    temperature: 6500,
}

export type FloorViewConfig = {
    material: MaterialOptions,
    grainDirection: string,
    fitted: boolean,
}
export type FloorViewOptions = OptionalProperties<FloorViewConfig>;

export const floorViewDefaults: FloorViewConfig = {
    material: {
        assetId: "materials/floor-wood-08"
    },
    grainDirection: "z",
    fitted: false,
}

export type ShowWallConfig = {
    wallOrder: number,
    show: boolean,
    island: boolean,
}
export type ShowWallOptions = OptionalProperties<ShowWallConfig>;

export const showWallDefaults: ShowWallConfig = {
    wallOrder: 0,
    show: true,
    island: false,
}

export type SavedViewConfig = {
    name: string,
    hidden: boolean,
    camera: CameraConfig,
    lighting: DirectionalLightingViewConfig,
    wallMaterial: MaterialOptions,
    walls: ShowWallConfig[],
}
export type SavedViewOptions = OptionalProperties<SavedViewConfig>;

export const savedViewDefaults: SavedViewConfig = {
    name: null,
    hidden: false,
    camera: cameraDefaults,
    lighting: directionalLightingViewDefaults,
    wallMaterial: { type: "WallPaint", tint: null },
    walls: [],
}

export type RoomViewConfig = {
    floor: FloorViewConfig,
    directionalLighting: DirectionalLightingViewConfig,
    tempIncludeFloor: boolean,
    tempIncludeGlobalLighting: boolean,
    baseMolding: string,
    crownMolding: string,
    wallMaterial: MaterialOptions,
    standardHeights: number[],
}
export type RoomViewOptions = OptionalProperties<RoomViewConfig>;

export const roomViewDefaults: RoomViewConfig = {
    floor: floorViewDefaults,
    directionalLighting: directionalLightingViewDefaults,
    tempIncludeFloor: false,
    tempIncludeGlobalLighting: false,
    baseMolding: null,
    crownMolding: null,
    wallMaterial: { type: "WallPaint", tint: "#B0B0B0" },
    standardHeights: [1.25, 2.5, 3.75, 5.0625, 6.3125, 7.5625, 8.8125, 10.0625, 11.3125, 12.625, 13.875, 15.125, 16.375, 17.625, 18.875, 20.1875, 21.4375, 22.6875, 23.9375, 25.1875, 26.4375, 27.6875, 29, 30.25, 31.5, 32.75, 34, 35.25, 36.5625, 37.8125, 39.0625, 40.3125, 41.5625, 42.8125, 44.125, 45.375, 46.625, 47.875, 49.125, 50.375, 51.625, 52.9375, 54.1875, 55.4375, 56.6875, 57.9375, 59.1875, 60.5, 61.75, 63, 64.25, 65.5, 66.75, 68.0625, 69.3125, 70.5625, 71.8125, 73.0625, 74.3125, 75.5625, 76.875, 78.125, 79.375, 80.625, 81.875, 83.125, 84.4375, 85.6875, 86.9375, 88.1875, 89.4375, 90.6875, 91.9375, 93.25, 94.5, 95.75],
}
